const sensorAuthorizationStates = {
  OK: 'ok',
  FAILING: 'failing',
  INACTIVE: 'inactive',
  IN_PROGRESS: 'in-progress',
  INSUFFICIENT_PERMISSION: 'insufficient-permission',
  DELETED: 'deleted',
  CLEANUP_REQUESTED: 'cleanup-requested',
  CLEANUP_IN_PROGRESS: 'cleanup-in-progress',
  CLEANUP_FAILED: 'cleanup-failed'
};

export default sensorAuthorizationStates;
